export default __webpack_public_path__ + "static/media/get-report.0adcec9d.png";